<template>
  <b-modal
      id="keyword-detail-modal"
      centered
      :title="$t('pages.keyword.detail.title')"
      title-class="font-18"
      size="xl"
      hide-footer
  >
    <b-card no-body v-if="historicalData" class="bg-light">
      <b-card-body>
        <b-row>
          <b-col md="6" xl="3" lg="3" sm="12">
            <keyword-top-stat-card
                icon="mdi-tag"
                :title="$t('pages.keyword.detail.core')"
                :text="historicalData.keyword_properties.core_keyword"
                :hint="$t('pages.keyword.detail.core_hint')"
            />
          </b-col>
          <b-col md="6" xl="3" lg="3" sm="12">
            <keyword-top-stat-card
                icon="mdi-filter-variant"
                :title="$t('pages.keyword.detail.difficulty')"
                :text="historicalData.keyword_properties.keyword_difficulty"
                :hint="$t('pages.keyword.detail.difficulty_hint')"
            />
          </b-col>
          <b-col md="6" xl="3" lg="3" sm="12">
            <keyword-top-stat-card
                icon="mdi-head-snowflake"
                :title="$t('pages.keyword.detail.impressions')"
                :text="historicalData.impressions_info.daily_impressions_average"
                :hint="$t('pages.keyword.detail.impressions_hint')"
            />
          </b-col>
          <b-col md="6" xl="3" lg="3" sm="12">
            <keyword-top-stat-card
                icon="mdi-cursor-default-click"
                :title="$t('pages.keyword.detail.clicks')"
                :text="historicalData.impressions_info.daily_clicks_average"
                :hint="$t('pages.keyword.detail.clicks_hint')"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" md="6" lg="3" xl="3" v-for="(impression, index) in impressions" :key="index">
            <keyword-bottom-stat-card
                :title="impression.title"
                :title-hint="impression.hint"
                :max="historicalData.impressions_info[impression.max]"
                :min="historicalData.impressions_info[impression.min]"
                :avg="historicalData.impressions_info[impression.avg]"
                :min-text="$t('pages.keyword.detail.min')"
                :max-text="$t('pages.keyword.detail.max')"
                :avg-text="$t('pages.keyword.detail.avg')"
            />
          </b-col>

          <b-col sm="6" md="6" lg="9" xl="9">
            <keyword-bottom-stat-card
                title="Bid"
                :max="historicalData.keyword_info.high_top_of_page_bid"
                :min="historicalData.keyword_info.low_top_of_page_bid"
                :avg="historicalData.impressions_info.bid"
                :min-text="$t('pages.keyword.detail.bottom_card.min')"
                :max-text="$t('pages.keyword.detail.bottom_card.max')"
                :avg-text="$t('pages.keyword.detail.bottom_card.avg')"
                :min-hint="$t('pages.keyword.detail.bottom_card.min_hint')"
                :max-hint="$t('pages.keyword.detail.bottom_card.max_hint')"
                :avg-hint="$t('pages.keyword.detail.bottom_card.avg_hint')"
            />
          </b-col>
        </b-row>
        <p class="text-gray font-size-10">
          {{ $t('pages.keyword.detail.based_google') }}
        </p>
      </b-card-body>
    </b-card>
  </b-modal>
</template>

<script>
import KeywordTopStatCard from "./KeywordTopStatCard";
import KeywordBottomStatCard from "./KeywordBottomStatCard";

export default {
  name: "KeywordDetailModal",
  components: {KeywordBottomStatCard, KeywordTopStatCard},
  props: ['historicalData'],
  data() {
    return {
      impressions: [
        {
          title: 'Ad Position',
          min: 'ad_position_min',
          max: 'ad_position_max',
          avg: 'ad_position_average',
          hint: this.$t('pages.keyword.detail.position_hint')
        },
        {
          title: 'CPC',
          min: 'cpc_min',
          max: 'cpc_max',
          avg: 'cpc_average',
          hint: this.$t('pages.keyword.detail.cpc_hint')
        },
        {
          title: 'Impressions',
          min: 'daily_impressions_min',
          max: 'daily_impressions_max',
          avg: 'daily_impressions_average',
          hint: this.$t('pages.keyword.detail.impression_hint')
        },
        {
          title: 'Clicks',
          min: 'daily_clicks_min',
          max: 'daily_clicks_max',
          avg: 'daily_clicks_average',
          hint: this.$t('pages.keyword.detail.click_hint')
        },
        {
          title: 'Cost',
          min: 'daily_cost_min',
          max: 'daily_cost_max',
          avg: 'daily_cost_average',
          hint: this.$t('pages.keyword.detail.cost_hint')
        }
      ],
    }
  }
}
</script>

<style scoped>
/deep/ .modal-body {
  padding: 0 !important;
}

@media (min-width: 1200px) {
  /deep/ .modal-xl {
    max-width: 1500px !important;
  }
}

@media (max-width: 1200px) {
  /deep/ .modal-xl {
    max-width: 95% !important;
  }
}

</style>